import React, { useEffect, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import ReactPaginate from 'react-paginate'
import { nextPaginationArrow, prevPaginationArrow } from '../SvgPaths/SvgPaths'
import { useNavigate } from 'react-router-dom'
import likeicon from '../../assets/images/png/like-icon.png'
import {
  addProducttoWishlist,
  getWishlistProducts
} from '../../services/WishlistServices'
import wishlistSelectedIcon from '../../assets/images/png/wishlistSelectedIcon.png'
import FeatureAdds from '../AllProdutcs/FeatureAdds'
import { getProducts } from '../../services/ProductsServices'

const InnovativeProducts = () => {
  const navigate = useNavigate()
  const [minPrice, setMinPrice] = useState('')
  const [maxPrice, setMaxPrice] = useState('')
  const [productsToBeShown, setProductsToBeShown] = useState(12)
  const [pageNumber, setPageNumber] = useState(1)
  const [products, setProducts] = useState([])
  const [favouriteItems, setFavouriteItems] = useState([])
  const [totalPages, setTotalPages] = useState(0)
  const tokenitem = localStorage.getItem('token')
  const getproducts = async () => {
    const totalCountRes = await getProducts('innovative', 1, 0, '', '', '')
    const totalCount = totalCountRes ? totalCountRes.length : 0

    const res = await getProducts(
      'innovative',
      pageNumber,
      productsToBeShown,
      minPrice,
      maxPrice,
      ''
    )
    console.log('innovative products', res)
    if (res) {
      setProducts(res.products)
      setTotalPages(Math.ceil(res.totalProducts / productsToBeShown))
    }
  }
  const getWishlistItems = async () => {
    const res = await getWishlistProducts(tokenitem)
    setFavouriteItems(res)
  }
  const addToWishlist = async id => {
    const tokenitem = localStorage.getItem('token')
    if (tokenitem) {
      const productId = id
      await addProducttoWishlist(productId, tokenitem)
      getWishlistItems()
    } else {
      localStorage.setItem('path', '/progressive-farming-solutions')
      navigate('/signin')
    }
  }

  const isInWishlist = id => {
    return (
      favouriteItems && favouriteItems.some(item => item?.productId?._id === id)
    )
  }

  const handlePageChange = ({ selected }) => {
    setPageNumber(selected + 1)
  }

  useEffect(() => {
    getproducts()
    getWishlistItems()
  }, [])

  return (
    <div className='bg_clr_light_yellow py-5'>
      <div className='container px-sm-5 px-2'>
        <div>
          <div className=' mb-4'>
            <h1 className='ff_heebo fw-bold fs_2xl'>
              <span className='clr_dark_green'>Progressive </span>
              Farming Solution
            </h1>
          </div>

          <div className='d-flex align-items-center gap-1'>
            <p className='mb-0'>SHOW:</p>
            <input
              className='product-number-input'
              value={productsToBeShown}
              onChange={e => {
                const inputValue = parseInt(e.target.value)
                if (inputValue < 6) {
                  setProductsToBeShown(6)
                } else {
                  setProductsToBeShown(inputValue)
                }
              }}
              type='number'
            />
          </div>
        </div>

        <div className='overflow-x-hidden'>
          <Row>
            <Col className='mt-4' lg={3}>
              <FeatureAdds />
            </Col>
            <Col className='mt-4' lg={9}>
              <div>
                {products.length === 0 ? (
                  <div className='py-5 mt-4 bg-white rounded-2'>
                    <div className='py-4'>
                      <h2 className='text-center clr_dark_green ff_heebo fw-medium'>
                        No Product found
                      </h2>
                    </div>
                  </div>
                ) : (
                  <div className='row g-4'>
                    {products.map((item, index) => (
                      <div className='col-md-4 col-sm-6' key={index}>
                        <div className='product-card bg-white rounded-4 shadow-sm position-relative h-100 overflow-hidden d-flex flex-column'>
                          {/* Wishlist Button */}
                          <div
                            className='wishlist-btn position-absolute top-0 end-0 m-2'
                            onClick={() => addToWishlist(item?._id)}
                          >
                            {isInWishlist(item?._id) ? (
                              <img
                                width={22}
                                src={wishlistSelectedIcon}
                                alt='wishlistIcon'
                              />
                            ) : (
                              <img
                                width={22}
                                src={likeicon}
                                alt='wishlistIcon'
                              />
                            )}
                          </div>

                          {/* Discount Badge */}
                          {item?.discountPrice && (
                            <span className='discount-badge position-absolute top-0 start-0 m-2 px-3 py-1 rounded-pill'>
                              {Math.round(
                                ((item.price - item.discountPrice) /
                                  item.price) *
                                  100
                              )}
                              % OFF
                            </span>
                          )}

                          {/* Product Image */}
                          <div
                            className='text-center flex-grow-1 d-flex align-items-center justify-content-center p-3 cursor_pointer'
                            onClick={() =>
                              navigate(`/product-details/${item?._id}`)
                            }
                          >
                            <img
                              src={item?.images[0]}
                              alt={item?.name}
                              className='product-img img-fluid'
                            />
                          </div>

                          {/* Product Info */}
                          <div className='p-3'>
                            <p
                              className='ff_heebo fw-semibold fs-6 text-dark text-capitalize mb-2 cursor_pointer'
                              onClick={() =>
                                navigate(`/product-details/${item?._id}`)
                              }
                            >
                              {item?.name}
                            </p>
                            <div className='d-flex align-items-center justify-content-between'>
                              <p className='fw-bold fs-5 text-success mb-0'>
                                ₹{item?.discountPrice}
                              </p>
                              <p className='text-muted text-decoration-line-through mb-0'>
                                ₹{item?.price}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </Col>
          </Row>
          <div className='d-flex flex-column flex-sm-row gap-3 mt-4 align-items-center justify-content-between'>
            <p className='mb-0 ff_heebo fw-medium fs_xsm clr_dark_grey_3'>
              Showing {productsToBeShown} - {products.length} of{' '}
              {products.length} results
            </p>
            <div className='pagination-container'>
              <ReactPaginate
                previousLabel={prevPaginationArrow}
                nextLabel={nextPaginationArrow}
                pageCount={totalPages > 0 ? totalPages : 1}
                onPageChange={handlePageChange}
                containerClassName={'pagination justify-content-end mb-0'}
                previousLinkClassName={'pagination__link'}
                nextLinkClassName={'pagination__link'}
                pageClassName={
                  'pagination__page d-flex align-items-center justify-content-center clr_dark_grey_3 mx-1 ff_heebo fw-medium fs_xsm'
                }
                disabledClassName={'pagination__link--disabled'}
                activeClassName={
                  'pagination__link--active d-flex align-items-center justify-content-center text-white ff_heebo fw-medium fs_xsm'
                }
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default InnovativeProducts
